// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { EventText2_abstract } from './../abstract/SagaSchema/EventText2_abstract';
export class EventText2 extends EventText2_abstract {}
